const CART_NOTIFIER_LOAD_SUCCESS = 'CART_NOTIFIER_LOAD_SUCCESS';

const CART_NOTIFIER_LOAD_URL = '/cart/notifier/load';

const REDUCER_CART_NOTIFIER_NAME = 'cartNotifier';

export {
  CART_NOTIFIER_LOAD_SUCCESS,

  CART_NOTIFIER_LOAD_URL,

  REDUCER_CART_NOTIFIER_NAME,
};
